export default "__VITE_ASSET__B3JbJZ_s__"